import * as z from "zod";
import { fredChartSchema } from "./fred-chart-schema";
import { imageChartSchema } from "./image-chart-schema";
import { orgChartSchema } from "./orgchart-chart-schema";
import { sfaaChartSchema } from "./sfaa-chart-schema";

/** The fence language of a chart block in an assistant answer: ```chart. */
export const CHART_LANGUAGE = "chart";

/**
 * The blocks the agent writes itself, from the generated chart rules. Each names a source and a
 * range, never values: the chart fetches its points from the API, so a plotted figure cannot be
 * one the model typed.
 */
export const authoredChartSchema = z.discriminatedUnion("source", [
	fredChartSchema,
	sfaaChartSchema,
]);

/**
 * Every block the panel draws: the authored ones, plus an image `run_chart_code` drew and an org
 * chart `ask_org_chart` stored. An image is the exception to "never values", and its card says so.
 */
export const chartSchema = z.discriminatedUnion("source", [
	...authoredChartSchema.options,
	imageChartSchema,
	orgChartSchema,
]);

export type Chart = z.infer<typeof chartSchema>;

const parseJson = (text: string): unknown => {
	try {
		return JSON.parse(text);
	} catch {
		return undefined;
	}
};

/** Undefined while a streamed block is still incomplete, or when the agent wrote an invalid one. */
export const parseChart = (text: string): Chart | undefined => {
	const parsed = chartSchema.safeParse(parseJson(text));
	return parsed.success ? parsed.data : undefined;
};
